/* eslint-disable import/no-unused-modules */

import React, { ReactElement, ChangeEventHandler } from 'react'
import Text from '../../text'
import { Tickbox as StyledTick, StyledInput } from './styled-components'

interface ButtonProps {
  text: string
  id: number
  onValueChange?: ChangeEventHandler<HTMLInputElement>
  defaultChecked?: boolean
}

function TickBox({
  text,
  id,
  onValueChange,
  defaultChecked,
}: ButtonProps): ReactElement {
  return (
    <StyledTick>
      <StyledInput
        defaultChecked={defaultChecked}
        type="checkbox"
        id={String(id)}
        name={text}
        value={text}
        onChange={onValueChange}
      />
      <Text size="small">{text}</Text>
    </StyledTick>
  )
}

export default TickBox
